export function ArticlesPage({ render }) {
  return render();
}
